import React from 'react';
import { Link } from 'react-router-dom';
import { programData } from './data/ProgramData';

const ProgramsSection = () => {
  return (
    <section className="programs-section section" id="programs">
      <div className="section-inner">
        <span className="section-badge reveal">🐋 What We Do</span>
        <h2 className="section__title reveal">Our Programs</h2>
        <p className="section__subtitle reveal">Discover the initiatives driving real change for our oceans and marine ecosystems.</p>
        <div className="cards">
          {programData.map((program, index) => (
            <div className={`card reveal reveal-delay-${index + 1}`} key={index}>
              <div className="card-image-container">
                <img src={program.imgSrc} alt={program.title} />
              </div>
              <div className="card-content">
                <h3>{program.title}</h3>
                <p>{program.description}</p>
                <Link to="/programs" className="card-button">Learn More →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
